import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StarbaseDataService, TruncateString } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ContactRequestModel } from 'contact-us-form/lib/contact-requestModel';
import { ImageFile } from '../models/imageFile';

@Injectable({
  providedIn: 'root'
})
export class ContactRequestService extends StarbaseDataService<ContactRequestModel> {
  protected _staleDataTimeout: number;
  protected _getOneUri: string;
  protected _getAllUri: string;
  protected _postUri = '/api/ContactRequest';
  protected _cancellationUri = '/api/ContactRequest/SendCancellationEmail';
  protected _putUri: string;
  protected _deleteUri: string;
  protected _broadSearchUri: string;
  protected _requestTranscriptionUri ='/api/ContactRequest/RequestTranscription';


  constructor(private _http: HttpClient, private _webApi: WebApiService) {
    super(_http, _webApi);
  }

  requestTranscription(imgData: ImageFile): Observable<ContactRequestModel> {
    return this._http.get<ContactRequestModel>(this.server + this._requestTranscriptionUri + `?imageUID=${imgData.uid}`,
    { headers: this._webApi.getApiHeaders('get') }
    );
  }

  cancellationReason(reason: string, email: string): Observable<any> {
    reason = TruncateString(reason, 2000);
    const reqSubj = { name: 'Cancellation Reason', selected: true };
    const req = {
      uid: 0,
      createdDateTime: new Date(),
      createdByUser: email,
      firstName: '',
      lastName: '',
      emailAddress: email,
      subject: 'Cancel',
      subjects: [reqSubj],
      message: reason,
      phoneNumber: null,
      selected: false,
      guid: ''
    };
    return this.postData(this.postUri + '?sendUserEmail=false', req);
  }
}
